module.exports = "/_next/static/images/Destinations@3x-09f4115327d10f8a14378888791b06d0.webp";